import { Flex, Link } from '@iheartjane/reefer';
import { Form, useWatch } from '@iheartjane/reefer-hook-form';

import { MaxCharacterHelper } from '../MaxCharacterHelper';
import { DEFAULTS } from './types';
import type { TextFieldName } from './types';

export const LabeledTextField = ({
  name,
  label,
  maxLength,
  multiline = false,
  onRevert,
}: {
  label: string;
  maxLength: number;
  multiline?: boolean;
  name: TextFieldName;
  onRevert: () => void;
}) => {
  const value = useWatch({ name }) ?? DEFAULTS[name];
  // Emphasize the revert link (black) when the value differs from its default.
  const isModified = value !== DEFAULTS[name];
  const FieldComponent = multiline ? Form.TextAreaField : Form.TextField;
  return (
    <Flex flexDirection="column" gap={8}>
      <FieldComponent name={name} label={label} maxLength={maxLength} />
      <Flex justifyContent="space-between" alignItems="center">
        <MaxCharacterHelper value={value} maxLength={maxLength} />
        <Link
          onClick={onRevert}
          color={isModified ? 'grays-black' : 'grays-mid'}
          typography="body"
        >
          Revert to default
        </Link>
      </Flex>
    </Flex>
  );
};
